<template>
    <v-dialog v-model="show" max-width="500">
        <v-card class="DialogDel">
        <v-card-title>
            <div class="DialogDel_title text-h4">You are about to <strong>Delete</strong> a Lead</div>
        </v-card-title>
        <v-card-text v-if="lead">Are you sure you want to delete <strong>{{ lead.name }}</strong> Lead?</v-card-text>
        <v-card-actions>
            <v-btn color="primary" @click="handleConfirm">Delete</v-btn>
            <v-btn @click="handleCancel">Cancel</v-btn>
        </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { BUS_EVENTS } from '@/constants';
import { EventBus } from '@/utilities';
import { mapActions } from "vuex";

export default {
    name: 'DialogLeadDelete',
    props: {
        lead: {
            type: Object,
            default: null
        },
    },
    data () {
        return {
            show: false,
        }
    },
    methods: {
        ...mapActions(['deleteLead']),
        handleCancel () {
            this.show = false; //HIDE POP_UP
            EventBus.$emit(BUS_EVENTS.LEAD_DELETE, null); //RESET POP-UP LEAD
        },
        async handleConfirm () {
            this.show = false; //HIDE POP_UP
            EventBus.$emit(BUS_EVENTS.LEAD_DELETE, null); //RESET POP-UP LEAD
            const resultService = await this.deleteLead(this.lead.id);
            if(resultService.msg === 'Success'){
                // SHOW TOP ALERT
                EventBus.$emit(BUS_EVENTS.ALERT_TRIGGERED , { type: 'success', message: 'Lead Deleted Successfully', duration: 3e3, });
                EventBus.$emit(BUS_EVENTS.STATS_UPDATED );
            }else{
                console.log('Error',resultService);
                EventBus.$emit(BUS_EVENTS.ALERT_TRIGGERED , { type: 'error', message: 'Error', duration: 3e3, });
            }
        }
    },
    watch: {
        lead (val) {
            if (val) {
                this.show = true;
            } else{
                this.show = false;
            }
        },
    }
}
</script>

<style lang="scss" scoped>
    @import '~@/scss/colors.scss';
    .DialogDel {
        text-align: center;
        .DialogDel_title{
            color: $purple;
            font-size: 24px !important;
            line-height: 1;
            text-align: center;
            margin: auto;
        }
        .v-card__actions{
            justify-content: center;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/DialogLeadDelete.vue